// extracted by mini-css-extract-plugin
export default {"item":"InfoItem_item__VrQ3Q"};